<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t("AJOUTER_UN") : $t("MODIFICATION_DU") }} {{$t("RISK")}}  </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
        <div class="p-6">
         
          <p class="pt-4">{{ $t("activity") }}<b style="color: #ff6141" >*</b> </p>
              <vs-select
                v-model="input.activity"
                data-vv-validate-on="blur"
                v-validate="'required'"
                autocomplete
                name="activity"
                class="w-full"
            >
          <vs-select-item :key="item" :value="item.id" :text="item.name" v-for="item in activities" /></vs-select>
          <span class="text-danger text-sm" v-show="errors.has('riskProfile')">{{$t("riskProfile_error")}}</span>
          
         <!--  <p class="pt-4">{{ $t("riskDetails") }}<b style="color: #ff6141" >*</b> </p>
          <vs-input-number
            :min="0" 
            :max="100"
            v-validate="'required'"
            name="riskDetails"
            v-model="input.riskDetails"
            class="w-full"
            />
          
          <span class="text-danger text-sm" v-show="errors.has('riskDetails')">{{$t("riskDetails_error")}}</span>
           -->

          <p class="pt-4">{{ $t("initialRiskProbability") }}<b style="color: #ff6141" >*</b> </p>
          <vs-input-number
            :min="1" 
            :max="5"
            v-validate="'required'"
            name="initialRiskProbability"
            v-model="input.initialRiskProbability"
            class="w-full"
            />
          <span class="text-danger text-sm" v-show="errors.has('initialRiskProbability')">{{$t("initialRiskProbability_error")}}</span>
          
          <p class="pt-4">{{ $t("initialRiskSeverity") }}<b style="color: #ff6141" >*</b> </p>
          <vs-input-number
            :min="1" 
            :max="5"
            v-validate="'required'"
            name="initialRiskSeverity"
            v-model="input.initialRiskSeverity"
            class="w-full"
            />
          <span class="text-danger text-sm" v-show="errors.has('initialRiskSeverity')">{{$t("initialRiskSeverity_error")}}</span>
          
          <p class="pt-4">{{ $t("initialRisk") }}<b style="color: #ff6141" >*</b> </p>
          <vs-input-number
            disabled
            :min="1" 
            :max="25"
            v-validate="'required'"
            name="initialRisk"
            v-model="input.initialRisk"
            class="w-full"
            />
          
<!--           <span class="text-danger text-sm" v-show="errors.has('initialRisk')">{{$t("initialRisk_error")}}</span>
 -->          
        </div>
      </component>
  
      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="category_validate">{{$t("Soumettre")}}</vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t("Annuler")}}</vs-button>
      </div>
    </vs-sidebar>
  </template>
  
<script>
  
// For custom error message
import { Validator } from 'vee-validate'
  
const dict = {
  custom: {
  
    nametype: {
      required: 'Le champ tâche est obligatoire'
    }
  }
}
  
// register custom messages
Validator.localize('en', dict)
  
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  
const input_tempon = {
  activity:[],
  riskDetails: 1,
  initialRisk :1,
  initialRiskProbability:1,
  initialRiskSeverity:1
}
  
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      riskProfiles: [],
      input: JSON.parse(JSON.stringify(input_tempon)),
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    input: {
      deep: true,
      handler (newInput) {
        this.input.initialRisk = newInput.initialRiskSeverity * newInput.initialRiskProbability
      }
    },
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        
        this.input = JSON.parse(JSON.stringify(this.data))
        this.input.activity = this.data.activity.id
        
        this.initValues()
      }
    }
  },
  
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.input = JSON.parse(JSON.stringify(input_tempon))
    },
    category_validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitData()
        }
      })
    },
  
    async submitData () {
      this.$vs.loading()
      const input = JSON.parse(JSON.stringify(this.input))
  
      let url = 'risks/'
      let methods = 'post'
      const message = {
        error: this.$t('save_error'),
        success: this.$t('risk_save')
      }
      if (input.id) {
        url += `${input.id}/`
        methods = 'put'
        message.success = this.$t('risk_update')
      }
  
      this.$http[methods](url, input)
        .then((response) => {
          window.risks.getAllrisks()
          window.getPrendTaCom.success(message.success, response)
          this.$emit('closeSidebar')
          this.initValues()
        })
        .catch((error) => {
  
          const clefs = Object.keys(error.response.data)
          for (let i = 0; i < clefs.length; i++) {
            const item = clefs[i]
            let libelle = ''
            if (item === 'name') {
              libelle = this.$t('risk')
            }
            for (let j = 0; j < error.response.data[item].length; j++) {
              window.getPrendTaCom.error(`${libelle} :  ${error.response.data[item][j]}`)
            }
          }
  
          window.getPrendTaCom.error(message.error)
        })
    },
    getAllactivities () {
      this.$vs.loading()
      this.$http.get('activities/')
        .then((response) => {
          this.activities = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  
  },

  created () {
    this.getAllactivities()

  }
}
</script>
  
  <style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }
  
    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
  
      .img-upload {
        margin-top: 2rem;
  
        .con-img-upload {
          padding: 0;
        }
  
        .con-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
  
  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  
    &:not(.ps) {
      overflow-y: auto;
    }
  }
  </style>
  